export enum LocalStorageKeys {
  currentManageHotelId = 'CURRENT_MANAGE_HOTEL_ID',
  myCompanyId = 'MY_COMPANY_ID',
}
